// extracted by mini-css-extract-plugin
export default {"centered":"DialogueResponseContainer_centered__+LwFK","responseWrapper":"DialogueResponseContainer_responseWrapper__3-jRg","response":"DialogueResponseContainer_response__o1QaG"};